/** Re-export: el gate vive junto a hydrate para evitar `import()` dinámico en cold start. */
export { awaitSessionBootstrap, clearSessionBootstrapGate } from './hydrateSessionCachesFromBootstrap';
